import * as React from 'react';

import { CircularGradientEnvelope } from 'components/icons/circular-gradient';
import { automationWorkflowTileBlock as block } from '../../utils';
import { getComingSoonOverlayMessage } from './utils';

export interface ComingSoonOverlayProps {
  isAutopostingToPlatform?: boolean;
}

const ComingSoonOverlay: React.FC<ComingSoonOverlayProps> = ({
  isAutopostingToPlatform,
}) => (
  <div className={block('coming-soon-overlay')}>
    <div className={block('coming-soon-overlay-contents')}>
      <div className={block('coming-soon-overlay-icon')}>
        <CircularGradientEnvelope />
      </div>
      <span className={block('coming-soon-overlay-text')}>
        {getComingSoonOverlayMessage(isAutopostingToPlatform)}
      </span>
    </div>
  </div>
);

export default ComingSoonOverlay;
